import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Avatar,
  Button,
  Box,
  Stack,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const Header = ({ onMenuClick }) => {
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <AppBar position="sticky" elevation={0} sx={{ borderBottom: "1px solid", borderColor: "divider" }}>
      <Toolbar sx={{ minHeight: 64 }}>
        <Stack direction="row" alignItems="center" spacing={1} sx={{ flex: 1 }}>
          {onMenuClick ? (
            <Button
              color="inherit"
              onClick={onMenuClick}
              sx={{ minWidth: "auto", px: 1 }}
            >
              Menu
            </Button>
          ) : null}

          <Typography
            variant="h6"
            noWrap
            onClick={() => navigate("/home")}
            sx={{ cursor: "pointer", fontWeight: 800, letterSpacing: 0.3 }}
          >
            SEC@R
          </Typography>
        </Stack>

        <Box>
          <Stack direction="row" alignItems="center" spacing={1}>
            <IconButton color="inherit" size="small">
              <Avatar alt="User Avatar" src="/person.png" sx={{ width: 32, height: 32 }} />
            </IconButton>
            <Button color="inherit" onClick={handleLogout}>
              Logout
            </Button>
          </Stack>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;

// import React from 'react';
// import {
//     AppBar,
//     Toolbar,
//     Typography,
//     Grid,
//     IconButton,
//     Avatar,
//     Button,
//     useMediaQuery
// } from '@mui/material';
// import { useTheme } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';

// const Header = () => {
//     const navigate = useNavigate();
//     const theme = useTheme();
//     const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

//     const handleLogout = () => {
//         localStorage.clear();
//         navigate('/');
//     };

//     return (
//         <AppBar position="static">
//             <Toolbar>
//                 <Grid container alignItems="center">
//                     <Grid item xs={12} sm={6}>
//                         <Typography variant="h6" noWrap sx={{ textAlign: isMobile ? 'center' : 'left', width: '100%' }}>
//                             Salvus
//                         </Typography>
//                     </Grid>
//                     <Grid item xs={12} sm={6}>
//                         <Grid container justifyContent={isMobile ? 'center' : 'flex-end'} alignItems="center">
//                             <IconButton color="inherit" sx={{ p: 0, mr: isMobile ? 1 : 2 }}>
//                                 <Avatar alt="User Avatar" src="/person.png" />
//                             </IconButton>
//                             <Button color="inherit" onClick={handleLogout}>
//                                 Logout
//                             </Button>
//                         </Grid>
//                     </Grid>
//                 </Grid>
//             </Toolbar>
//         </AppBar>
//     );
// };

// export default Header;
